import { render, staticRenderFns } from "./MSolution.vue?vue&type=template&id=f5d63280&scoped=true&"
import script from "./MSolution.vue?vue&type=script&lang=js&"
export * from "./MSolution.vue?vue&type=script&lang=js&"
import style0 from "./MSolution.vue?vue&type=style&index=0&id=f5d63280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d63280",
  null
  
)

export default component.exports